<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { postAction,putAction } from '@/api/manage';
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('用户近半年用水统计'),
            option: {},
            url:{
                waterTypeWaterUse:"/jeecg-charge/meter/waterAnalysis/waterTypeWaterUse"
            },
            waterTypeWaterUse: {

            }
        }
    },
    mounted() {

    },
    methods: {
        init() {
            this.$nextTick(()=> {
                this.$refs.option.showLoading('default',{
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                })
                this.resetData()
                this.queryDeviceCount()
            })
            
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        queryDeviceCount() {
            putAction(this.url.waterTypeWaterUse, {}).then((res) => {
                if(res.success){
                    console.log(res.result)
                    this.waterTypeWaterUse.waterUseList = res.result.waterUseList
                    this.waterTypeWaterUse.monthStrList = res.result.monthStrList
                    this.waterTypeWaterUse.waterTypeNameList = res.result.waterTypeNameList
                    this.setOption()
                }
            })
        },
        setOption() {
            let seriesData = []
            let data = this.waterTypeWaterUse.waterUseList
            let category = this.waterTypeWaterUse.waterTypeNameList
            let xAxisData = this.waterTypeWaterUse.monthStrList
            for(let i = 0;i< data.length;i++) {
                seriesData.push({
                    name: category[i],
                    type: 'bar',
                    barMaxWidth: 14,
                    stack: 'sum',
                    smooth: true,
                    symbol: "none",
                    animationDelay: (i*200)-100,
                    animationDuration: 300,
                    data: data[i]
                })
                if(i == (data.length-1)) {
                    seriesData[i].itemStyle= {
                            normal: {
                                barBorderRadius:[20, 20, 0, 0]
                            }
                        }
                }
            }
            this.$refs.option.hideLoading()
            this.option = {
                color: ['#F6BB2F','#50E3C2', '#32C5FF','#0091FF','#0394FF','#4634FA','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'],
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                legend: {
                    type: 'scroll',
                    data: category,
                    textStyle: {
                        color: '#CEE2FF'
                    },
                    icon: 'circle',
                    itemHeight: 10,
                    left: 'left',
                    pageIconColor: '#aaa',
                    pageIconInactiveColor: '#2f4554',
                    pageTextStyle: {
                        color: 'rgb(91, 135, 195)'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    data: xAxisData,
                    splitLine: {
                        show: false
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: ['#074671'],
                        }
                    },
                    axisLabel: {
                        color: '#D1F3FF',
                        fontSize: 10
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dotted',
                            color: ['#074671'],
                        }
                    },
                    axisTick:{
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#D1F3FF',
                        fontSize: 10
                    }
                },
                series: seriesData
            };
        }
    }
}
</script>